export default __webpack_public_path__ + "static/media/OlanRei_natpis-transp-02-footer.55db46ee.png";